import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import {useRouter} from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'DataDoesNotExist',
  props: {
    modelValue: {
        type: Boolean,
        default: false,
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props

const router = useRouter();


const __returned__ = { router, props, ref, useRouter }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})